// initial state
// import axios from 'axios'
import thisAxios from '@/assets/js/http'

const state = {
  collapse: false,
  list: [
    {
      id: '1',
      icon: 'appstore',
      title: '应用管理',
      children: [
        {
          id: '1-1',
          title: '应用列表',
          path: '/apps'
        }
      ]
    },
    {
      id: '2',
      icon: 'team',
      title: '人员管理',
      children: [
        {
          id: '2-1',
          title: '人员列表',
          path: '/users'
        }
      ]
    },
    {
      id: '3',
      icon: 'stock',
      title: '报警策略管理',
      children: [
        {
          id: '3-1',
          title: '报警策略列表',
          path: '/policys'
        },
        {
          id: '3-2',
          title: '微信报警管理',
          path: '/wechat'
        }
      ]
    },
    {
      id: '4',
      icon: 'error-fill',
      title: '业务监控',
      children: [
        {
          id: '4-1',
          title: '业务异常监控定制',
          path: '/bizs'
        },
        {
          id: '4-2',
          title: '业务监控仪表盘',
          path: '/dashboard'
        }
      ]
    },
    {
      id: '5',
      icon: 'eye-fill',
      title: '端口监控管理',
      children: [
        {
          id: '5-1',
          title: '端口监控列表',
          path: '/ports'
        }
      ]
    },
    {
      id: '6',
      icon: 'IE-square-fill',
      title: 'URL监控管理',
      children: [
        {
          id: '6-1',
          title: 'URL监控列表',
          path: '/urls'
        },
        {
          id: '6-2',
          title: 'URL结果校验列表',
          path: '/urls_rule'
        }
      ]
    },
    {
      id: '7',
      icon: 'dashboard',
      title: '报警信息',
      children: [
        {
          id: '7-1',
          title: '历史报警信息',
          path: '/alarms'
        }
      ]
    }

  ]
}

// actions
const actions = {
  toggleCollapse ({ commit, state }) {
    commit('changeCollapse', !state.collapse)
  },
  fetchNavList ({ commit, state }) {
    var name = 'apusUserId'
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr === undefined || arr == null) {
      // var random = Date.now()
      // location.href = host + '/sso.htm?t='+random;
      return
    }
    // console.log('userId ' + (arr == null))
    // host + '/menuTree.htm?userId=' + arr[2]+"&t="+new Date().getTime(),
    thisAxios({
      method: 'get',
      url: '/menuTree.htm?userId=' + arr[2] + '&t=' + new Date().getTime()
    }).then(response => {
      var json = JSON.parse(response.data.message)
      commit('fetchNavList', json, !state.collapse)
    })
  }
}

// mutations
const mutations = {
  changeCollapse (state, val) {
    state.collapse = val
  },
  fetchNavList (state, list, val) {
    // console.log(list)
    state.list = list
    state.collapse = val
  }
}
// getters
const getters = {
  navList: state => state.list,
  navCollapse: state => state.collapse
}

export default {
  state,
  getters,
  actions,
  mutations
}
